import type { FieldValueResult } from '@/components/documents/Foxit/FormMapping/composables/FieldValueProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import type { MappedCartItem } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const useCemeteryFields = () => {
	const { findCartItems, getFieldPrice, getFieldDescription } =
		useFormFillHelper()

	const intermentDesc = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ??
			findCartItems(PbProductType.Cemetery, PbSubcategory.CemeteryInterment)

		return [
			{
				name: fieldName,
				value: getFieldDescription(items),
				format: false,
				section: 'cashAdvance',
			},
		]
	}

	const intermentPrice = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ??
			findCartItems(PbProductType.Cemetery, PbSubcategory.CemeteryInterment)

		return [
			{
				name: fieldName,
				value: getFieldPrice(items),
				format: true,
				section: 'cashAdvance',
				supplementalItems: items,
			},
		]
	}

	const intermentFields = (
		fieldNames: Record<string, string>
	): FieldValueResult[] => {
		const items = findCartItems(
			PbProductType.Cemetery,
			PbSubcategory.CemeteryInterment
		)

		return [
			...intermentDesc(fieldNames.description, items),
			...intermentPrice(fieldNames.price, items),
		]
	}

	const monumentMarkerAllowanceDesc = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ??
			findCartItems(
				PbProductType.Cemetery,
				PbSubcategory.CemeteryMonumentMarker
			)

		return [
			{
				name: fieldName,
				value: getFieldDescription(items),
				format: false,
				section: 'cashAdvance',
			},
		]
	}

	const monumentMarkerAllowancePrice = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ??
			findCartItems(
				PbProductType.Cemetery,
				PbSubcategory.CemeteryMonumentMarker
			)

		return [
			{
				name: fieldName,
				value: getFieldPrice(items),
				format: true,
				section: 'cashAdvance',
				supplementalItems: items,
			},
		]
	}

	const monumentMarkerAllowanceFields = (
		fieldNames: Record<string, string>
	): FieldValueResult[] => {
		const items = findCartItems(
			PbProductType.Cemetery,
			PbSubcategory.CemeteryMonumentMarker
		)

		return [
			...monumentMarkerAllowanceDesc(fieldNames.description, items),
			...monumentMarkerAllowancePrice(fieldNames.price, items),
		]
	}

	const cemeteryChargesPrice = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items = findCartItems(PbProductType.Cemetery, PbSubcategory.Other)

		return [
			{
				name: fieldName,
				value: getFieldPrice(items),
				format: true,
				section: 'cashAdvance',
				supplementalItems: items,
			},
		]
	}

	return {
		intermentDesc,
		intermentPrice,
		intermentFields,
		monumentMarkerAllowanceDesc,
		monumentMarkerAllowancePrice,
		monumentMarkerAllowanceFields,
		cemeteryChargesPrice,
	}
}
